<template lang="pug">
  //- Barra de filtros de búsqueda
  .b2b-filters
    b2b-search-bar
      div.block(slot='header')
        ods-tooltip.ods-ml-4(:content='$t("buttons.refresh_tooltip")', placement='bottom')
          ods-button(
            icon='ods-icon-refresh',
            size='medium',
            @click="activeRefreshResults")
        ods-tooltip.ods-ml-4(:content='$t("documentation.buttons.new_document_tooltip")', placement='bottom')
          ods-button(
            v-if='canAdminIndra || canAdminDocumentation'
            size='medium',
            icon='ods-icon-upload'
            @click.native='onShowDialogAddDocumentation')
            | {{ $t('documentation.buttons.new_document') }}
      div(slot='body')
        ods-form.b2b-filters__area(
          :model='filterForm',
          :rules='rules',
          ref='filterForm',
          @submit.native.prevent='')
          ods-form-item.first-input(prop='firstValue')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='filterForm.firstValue',
              :placeholder='$t("msg_generics.advanced_search")',
              @change='getFirstValue')

              ods-option(
                v-for='option in options',
                :key='option.col',
                :label='$t(option.value)',
                :disabled='option.selected',
                :value='option')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              //- Select type
              div(v-if="selected.componente === 'select'")
                ods-form-item.others-input(prop='secondValueSelect')
                  ods-select(v-if="selected.prop === 'projectId'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.name',
                      :value='option.id')
                  ods-select(v-else-if="selected.prop === 'idCategory'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in optionsCategories',
                      :key='option.id',
                      :label='option.name',
                      :value='option.id')
                  ods-select(v-else-if="selected.prop === 'idLanguage'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in optionsLanguages',
                      :key='option.id',
                      :label='option.name',
                      :value='option.id')
              //- Input type
              div(v-else-if="selected.componente === 'input' && selected.tipo === 'string'")
                ods-form-item.others-input(prop='secondValue')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValue',
                    @input='getSecondValue')
              div(v-else)
                ods-form-item.others-input(prop='secondValueNumber')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model.number='filterForm.secondValueNumber',
                    @input='getSecondValue')
          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              ods-button(
                icon='ods-icon-plus',
                size='medium',
                circle,
                @click.native="onSubmit('filterForm')")

    .b2b-filters__container(v-if='listSelectedFiltersDocumentation.length > 0')
      transition-group.b2b-filters__group(
        name='ods-fade-in-linear',
        tag='div')
        ods-popover(
          key='icon-delete-filters',
          placement='top-start',
          trigger='hover',
          :content='$t("msg_generics.popover_clean_filters")')
          ods-button.clean-filters(
            slot='reference',
            type='neutral',
            size='small',
            icon='ods-icon-delete',
            @click='handleDeleteAllFilters')

        .b2b-filters__button(
          v-for='(filter, index) in listSelectedFiltersDocumentation',
          :key='index')
          b2b-filter-button-documentacion(
            :filter='filter',
            @closeTag='resetSelectedOneOption')
    ods-dialog(
          ref='dialogAddDocumentation',
          :title='$t("documentation.dialog_add_documentation.title")',
          :visible.sync='isShowDialogAddDocumentation',
          :append-to-body='true',
          @close='handleCloseDialog',
          width='40%')
          ods-form(
            ref='formDialogAddDocumentation',
            :rules='rulesDialogAddDocumentation',
            :model='formDialogAddDocumentation',
            size='mini')
            ods-form-item(
              :label='$t("documentation.dialog_add_documentation.nombre.label")',
              prop='nombre')
              ods-input(
                v-model='formDialogAddDocumentation.nombre')
            ods-form-item(
              ref='url',
              :label='$t("documentation.dialog_add_documentation.url.label")',
              prop='url')
              ods-input(
                v-model='formDialogAddDocumentation.url')
            ods-form-item(
              :label='$t("documentation.dialog_add_documentation.project.label")',
              prop='servicio')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='formDialogAddDocumentation.servicio',
                filterable,
                clearable,
                :placeholder='$t("documentation.dialog_add_documentation.project.placeholder")')
                ods-option(
                  v-for='option in optionsFilterService',
                  :key='option.id',
                  :label='option.name',
                  :value='option.id')
            ods-form-item(
              :label='$t("documentation.dialog_add_documentation.categoria.label")'
              prop='categoria')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='formDialogAddDocumentation.categoria',
                filterable,
                clearable,
                :placeholder='$t("documentation.dialog_add_documentation.categoria.placeholder")')
                ods-option(
                  v-for='option in optionsCategories',
                  :key='option.id',
                  :label='option.name',
                  :value='option.id')
            ods-form-item(
              :label='$t("documentation.dialog_add_documentation.idioma.label")',
              prop='idioma')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='formDialogAddDocumentation.idioma',
                filterable,
                :placeholder='$t("documentation.dialog_add_documentation.idioma.placeholder")')
                ods-option(
                  v-for='option in optionsLanguages',
                  :key='option.id',
                  :label='option.name',
                  :value='option.id')
            ods-form-item(prop='fichero', ref='form-item-upload')
              ods-upload(
              v-model='formDialogAddDocumentation.fichero',
              ref='upload',
              action='#',
              :auto-upload='false',
              :on-change='onSuccessUpload',
              :on-remove='handleRemoveUpload',
              :file-list='fileList')
                ods-button(
                  icon='ods-icon-plus',
                  size='small',
                  circle)
                  | {{ $t('msg_generics.file_selected') }}
          span.dialog-footer(slot='footer')
          ods-button.add-documentation-button(
            style='float: right;',
            type='primary',
            @click.native='onSubmitAddDocumentation("formDialogAddDocumentation")')
            | {{ $t('msg_generics.load_document') }}
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonDocumentacion from '@/views/documentacion/documentos/B2bFilterButtonDocumentacion'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-documentacion-documentos',
  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },
  mixins: [Utils],
  components: {
    B2bSearchBar,
    B2bFilterButtonDocumentacion
  },

  data () {
    const validaUrlFile = (rule, value, callback) => {
      if (!this.formDialogAddDocumentation.url && !this.formDialogAddDocumentation.fichero) {
        callback(new Error(this.$t('documentation.dialog_add_documentation.urlorfile_required')))
      } else {
        callback()
      }
    }
    return {
      fileList: [],
      isShowDialogAddDocumentation: false,
      formDialogAddDocumentation: {
        servicio: null,
        nombre: null,
        url: null,
        categoria: null,
        idioma: null,
        fichero: null,
        deletefile: false
      },
      selected: {},
      selectedFilters: [],
      options: {},
      optionsService: [],
      optionsCategories: [],
      optionsLanguages: [],

      filterForm: {
        firstValue: '',
        filterDatePickerValue: [],
        secondValue: '',
        secondValueNumber: '',
        secondValueSelect: ''
      },
      rules: {
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 3, message: this.$t('msg_generics.min_three_letters') }
        ],
        secondValueNumber: [
          { required: true, message: this.$t('msg_generics.field_required') },
          { type: 'number', message: this.$t('msg_generics.number_required') }
        ],
        secondValueSelect: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ]
      },
      // Reglas Validación
      rulesDialogAddDocumentation: {
        nombre: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          },
          {
            max: 50,
            message: this.$t('validations.maxlenght', { maxlenght: 50 }),
            trigger: 'change'
          }
        ],
        url: [
          { max: 50, message: this.$t('validations.maxlenght', { maxlenght: 255 }), trigger: 'change' },
          { validator: validaUrlFile, trigger: 'click' }
        ],
        idioma: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          }
        ],
        fichero: [
          { validator: validaUrlFile, trigger: 'click' }
        ]
      }
    }
  },

  computed: {
    ...mapGetters([
      'canAdminIndra',
      'canAdminDocumentation',
      'optionsFilterDocumentationCategories',
      'optionsFilterLanguages',
      'optionsFilterService',
      'queryDocumentation',
      'listSelectedFiltersDocumentation'
    ])
  },
  watch: {
    '$route' (to) {
      this.listSelectedFiltersDocumentation = this.listSelectedFiltersDocumentation // eslint-disable-line
    }
  },

  methods: {
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'handleUploadDocumentation',
      'getDocumentationCategories',
      'getLanguages',
      'getOptionsService',
      'optionsFilterServiceState',
      'queryDocumentationState',
      'listSelectedFiltersDocumentationState',
      'optionsServicesEnabledState',
      'getDocumentation'
    ]),

    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddDocumentation.fichero = file
      this.$refs.formDialogAddDocumentation.validateField('fichero')
    },

    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },

    // Reseteo al cerrar dialogo
    handleCloseDialog () {
      this.$refs.formDialogAddDocumentation.resetFields()
      this.handleRemoveUpload()
      this.formDialogAddDocumentation.fichero = null
    },

    getFirstValue (data) {
      this.filterForm.secondValue = ''
      this.filterForm.secondValueSelect = ''
      this.$refs.filterForm.clearValidate()
      this.selected = data
    },

    getSecondValue (data) {
      if (this.selected.componente === 'select') {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = option.name
      } else if (this.selected.componente === 'input') {
        this.selected.query = data
        this.selected.labelText = data
      }

      this.$refs.filterForm.clearValidate()
    },

    async onShowDialogAddDocumentation () {
      this.isShowDialogAddDocumentation = true
    },

    onSubmitAddDocumentation (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('onSubmitAddDocumentation!!!   ', this.fileList)
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.upload_attachment')
          })
          try {
            const query = {
              documentation: this.fileList[0],
              projectId: this.formDialogAddDocumentation.servicio,
              categoryId: this.formDialogAddDocumentation.categoria,
              name: this.formDialogAddDocumentation.nombre,
              url: this.formDialogAddDocumentation.url,
              deletefile: this.formDialogAddDocumentation.deletefile,
              languageId: this.formDialogAddDocumentation.idioma
            }
            await this.handleUploadDocumentation(query)
            const dataQuery = {
              query: this.queryDocumentation
            }
            const response = await this.getDocumentation(dataQuery)
            console.log('getDocumentation 5')
            this.totalResults = response.data.totalElements

            this.$notify({
              title: this.$t('msg_generics.upload_attachment_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            this.$emit('on-uploaded', query)
          } catch (error) {
            console.log('onSubmitAddDocumentation CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogAddDocumentation = false
          }
        } else {
          console.log('error submit!!!!')
          return false
        }
      })
    },
    onSubmit (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.filter_selected')
          })
          try {
            console.log('1 Filtro Seleccionado: ', this.selected)
            const dataQuery = {
              query: {}
            }
            const column = this.selected.prop
            switch (column) {
              case 'projectId':
                this.queryDocumentation.projectId = this.selected.query
                break
              case 'name':
                this.queryDocumentation.name = this.selected.query.trim()
                break
              case 'idCategory':
                this.queryDocumentation.categoryId = this.selected.query
                break
              case 'idLanguage':
                console.log('idLanguage ', this.selected.query)
                this.queryDocumentation.languageId = this.selected.query
                break
              default:
                break
            }
            this.selectedFilters = this.listSelectedFiltersDocumentation

            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersDocumentationState(this.selectedFilters)

            this.selected = {}
            this.$refs[formName].resetFields()
            // Reseteamos el filtro de fechas aparte porque con resetFields no se resetea bien
            // cuando le ponemos un formato de fecha determinado
            this.filterForm.filterDatePickerValue = []

            this.queryDocumentation.page = 0
            await this.queryDocumentationState(this.queryDocumentation)
            dataQuery.query = this.queryDocumentation

            const response = await this.getDocumentation(dataQuery)
            console.log('getDocumentation 2 ', this.queryDocumentation)
            this.totalResults = response.data.totalElements
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.handleDeleteAllFilters()
          } finally {
            this.initForm()
            load.close()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.queryDocumentationState(this.queryDocumentation)
        dataQuery.query = this.queryDocumentation
        const response = await this.getDocumentation(dataQuery)
        console.log('getDocumentation 3')
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleDeleteAllFilters () {
      console.log(this.selectedFilters)
      this.selectedFilters = []
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })
      try {
        this.selectedFilters = this.listSelectedFiltersDocumentation.map(item => {
          item.labelText = ''
          item.query = ''
          item.selected = false
          return item
        })

        console.log('CLEAR FILTERS: ', this.selectedFilters)
        await this.listSelectedFiltersDocumentationState(this.selectedFilters)

        this.queryDocumentation.name = ''
        this.queryDocumentation.projectId = ''
        this.queryDocumentation.categoryId = ''
        this.queryDocumentation.languageId = ''

        dataQuery.query = this.queryDocumentation
        const response = await this.getDocumentation(dataQuery)
        console.log('getDocumentation 4')
        await this.queryDocumentationState(this.queryDocumentation)
        this.totalResults = response.data.totalElements
        this.selectedFilters = []
        await this.listSelectedFiltersDocumentationState(this.selectedFilters)

        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)
      } catch (error) {
        console.log('getDocumentation CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        this.initForm()
        load.close()
      }
    },
    initForm () {
      if (!this.options.nombre.selected) {
        this.filterForm.firstValue = this.options.nombre
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
    },

    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      console.log('resetSelectedOneOption: ', data)
      this.resetOneOption(this.options, data.filter)
      await this.listSelectedFiltersDocumentationState(data.listAfterRemove)
      console.log('data.listAfterRemove: ', data.listAfterRemove)
      console.log('this.listSelectedFiltersDocumentation: ', this.listSelectedFiltersDocumentation)
      this.initForm()
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 404:
        case 409:
        case 415:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },
  async created () {
    try {
      this.options = JSON.parse(JSON.stringify(this.filterOptions))

      // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
      this.checkListFilterSelected(this.options, this.listSelectedFiltersDocumentation)

      const optionsCategoriesPromise = this.getDocumentationCategories()
      const optionsLanguagesPromise = this.getLanguages()

      this.optionsCategories = await optionsCategoriesPromise
      if (this.optionsCategories) {
        for (let index = 0; index < this.optionsCategories.length; index++) {
          this.optionsCategories[index].name = this.$t('documentation_category.' + this.optionsCategories[index].name)
        }
        this.optionsCategories.sort((a, b) => (a.name.toUpperCase().localeCompare(b.name.toUpperCase())))
      }
      this.optionsLanguages = await optionsLanguagesPromise
      if (this.optionsLanguages) {
        for (let index = 0; index < this.optionsLanguages.length; index++) {
          this.optionsLanguages[index].name = this.$t('documentation_language.' + this.optionsLanguages[index].name)
        }
        this.optionsLanguages.sort((a, b) => (a.name.toUpperCase().localeCompare(b.name.toUpperCase())))
      }

      // Si el usuario sólo tiene un servicio, quitamos el filtro de servicios
      if (this.optionsFilterService.length < 2) {
        delete this.options.servicio
      }
      this.initForm()
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },
  updated () {
    if (this.optionsFilterService.length > 1 && this.options.servicio) {
      this.options.servicio.options = this.optionsFilterService
    }
    this.options.categoria.options = this.optionsFilterDocumentationCategories
    this.options.idioma.options = this.optionsFilterLanguages
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ods-input__prefix {
  height: 72px !important;
}
.b2b-filters {
  ::v-deep .ods-input__suffix {
  height: 72px !important;
  }
  ::v-deep .ods-tag--secondary {
    background-color: #e4eef2 !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive);
  }
  ::v-deep .ods-icon-close, body .ods-icon-close {

    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
  }
  ::v-deep .ods-tag {

    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
  }
  ::v-deep .ods-select .ods-tag {
    display: inline-flex;
    margin: 2px 0 -52px 6px;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  .ods-button {
    display: inline;
    margin-right: rem(24);
  }

  .ods-form-item {
    .info {
      font-size: 18px;
      font-weight: 500;
      color: #060E14;
      text-transform: capitalize;
      margin-bottom:'0px';
    }
  }

  .ods-form-item.upload-attachment{
    margin-bottom: 12px;
  }

  .ods-form-item.labelAttachments{
    margin-bottom: 0px;
  }

  .add-invoice-button{
    margin-top: 15px;
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }

    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
}
</style>
